<div *ngIf="communicationUtilisateur " class="message-central couleur-{{ communicationUtilisateur?.couleur }}" [ngClass]="classeModeApplication">
	<span class="texte-message-information texte-message-couleur-{{ communicationUtilisateur?.couleur }}">{{ messageDansLaLangueUtilisateur }}</span>
</div>